module.exports = __webpack_public_path__ + "img/pic8.3cce5a59.png";